import styles from "../../styles/herobanner.module.css";

const HeroBanner = () => {
    return (
        <main className={`${styles.bg} mt-28 w-full`} id="top">
            <div style={{ backgroundColor: `rgba(160,139,122,0.9)`, height: "500px" }} >
                <div className='max-w-screen-lg mx-auto flex flex-col md:flex-col lg:flex-row justify-between' >
                    <div className='pt-36 lg:pt-44 pl-12' data-aos="fade-right" data-aos-duration="1000">

                        <h1 className='text-center lg:text-left text-black font-semibold text-xl lg:text-5xl'> Garments accessories Manufacturers </h1>
                        <h1 className='text-center lg:text-left text-black font-normal text-lg lg:text-2xl lg:pt-1'>in China & Bangladesh</h1>
                    </div>

                    {/* image  */}
                    <div className='w-82 h-48  lg:h-96 mt-4'>
                        <img className=' w-full h-full object-contain' src="../../../images/hero.jpg" alt="hero" />
                    </div>
                </div>
            </div>

        </main>
    );
};

export default HeroBanner;

